<template>
  <v-app>
    <!-- 화면 영역 -->
    <v-main>
      <div>
         <!-- 홈 화면 컴포넌트 -->
        <FirstScreen
          v-if="currentScreen === 'home'"
          @move="handleChangeScreen"
        ></FirstScreen>
        <!-- 메인 화면 컴포넌트 (서비스코드, 유저코드 전달) -->
        <MainScreen
          v-if="currentScreen === 'main'"
          :param-service-code="paramServiceCode"
          :param-user-code="paramUserCode"
          @move="handleChangeScreen"
        ></MainScreen>
      </div>
    </v-main>
    <!-- 푸터 영역 -->
    <footer>
      <ul class="inner info">
        <li class="talk">
          <em class="tit">고객센터</em>
          <a
            @click.prevent="openUrl(`https://pf.kakao.com/_xbdUKs`)"
            target="_blank"
            >톡 채널 바로가기</a
          >
        </li>
        <li class="privacy">
          <ul>
            <li>
              <a
                @click.prevent="
                  openUrl(
                    `https://terms.daeguro.co.kr:45028/agreement/agreement3.htm`
                  )
                "
                target="_blank"
                >개인정보처리방침</a
              >
            </li>
            <li>대구광역시 서구 북비산로 369, 2층</li>
            <li>팩스번호 : 070-8220-5229</li>
            <li class="copy">ⓒ INSUNGDATA ALL RIGHTS RESERVED</li>
          </ul>
        </li>
      </ul>
    </footer>
  </v-app>
</template>

<script>
// 컴포넌트 import
import FirstScreen from "@/components/FirstScreen.vue";
import MainScreen from "@/components/MainScreen.vue";

export default {
  name: "App",
  components: {
    FirstScreen,
    MainScreen,
  },
  mounted() {
    // URL 파라미터 체크 및 초기 화면 설정
    this.checkScreen();
    // 브라우저 뒤로가기 이벤트 리스너 등록
    window.addEventListener("popstate", this.handlePopState);
  },
  data() {
    return {
      currentScreen: "home", // 현재 화면 상태 (home/main)
      paramServiceCode: "", // URL 파라미터로 받은 서비스 코드
      paramUserCode: "", // URL 파라미터로 받은 유저 코드
    };
  },
  methods: {
    // URL 파라미터 체크 및 초기 화면 설정 메서드
    checkScreen() {
      const params = new URLSearchParams(window.location.search);
      // serviceCode 파라미터가 있으면 main 화면으로 설정
      if (params.has("serviceCode")) {
        this.paramServiceCode = params.get("serviceCode");
        this.currentScreen = "main";
      }
      // userCode 파라미터가 있으면 저장
      if (params.has("userCode")) {
        this.paramUserCode = params.get("userCode");
      }
      // 브라우저 히스토리에 초기 상태 추가
      window.history.pushState({ screen: "home" }, "");
    },
    // 화면 전환 처리 메서드
    handleChangeScreen(newScreen, serviceCode, userCode) {
      this.currentScreen = newScreen;
      this.paramServiceCode = serviceCode;
      this.paramUserCode = userCode;
      // 브라우저 히스토리에 새로운 상태 추가
      if (userCode) {
        window.history.pushState(
          { screen: newScreen, serviceCode, userCode },
          ""
        );
      } else {
        window.history.pushState({ screen: newScreen, serviceCode }, "");
      }
    },
    // 브라우저 뒤로가기 처리 메서드
    handlePopState(event) {
      if (event.state) {
        const { screen, serviceCode, userCode } = event.state;
        this.currentScreen = screen || "home";
        this.paramServiceCode = serviceCode || "";
        this.paramUserCode = userCode || "";
      }
    },
    // 외부 URL 열기 메서드
    openUrl(url) {
      window.open(url, "_blank");
    },
  },
};
</script>

<style>
@import "@/assets/css/common.css";
@import "@/assets/css/customer.css";
</style>
